import {ContactForm} from '../types/contact-form.types'
import {ContactFormFieldsFragment} from '../../../../__generated__/datocms.types'
import {parseCallToAction} from './call-to-action.serde'

export function parseContactForm(form: ContactFormFieldsFragment): ContactForm {
  const item = form as Required<typeof form>

  return {
    alternativeCallToActionTitle: item.alternativeCallToActionTitle,
    callToAction1: parseCallToAction(item.callToAction1),
    callToAction2: parseCallToAction(item.callToAction2),
  }
}
